import React from "react";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import BillingSection from "./BillingSection";
import EventSection from "./EventSection";
import UserDetailsSection from "./UserDetailsSection";
import EmiInformation from "./EmiInformation";

const OrderDetail = ({ loading, error, details, getDetials }) => {
  const order = details && typeof details === "object" && !Array.isArray(details)
    ? details
    : null;

  return (
    <MainComponentWrapper errorInfo={error} Loading={loading}>
      <div className="event-order-detail-body">
        {!loading && !order && !error && (
          <p className="event-order-detail-empty">Order details not available.</p>
        )}
        {order && (
          <>
            <EventSection
              eventDetials={order.event}
              details={order}
              loading={loading}
            />
            {order.paymentType === "emi" && <EmiInformation details={order} />}

            <BillingSection
              getDetials={getDetials}
              loading={loading}
              error={error}
              details={order}
            />
            <UserDetailsSection
              details={order}
              isLoading={loading}
              isError={error}
              getDetials={getDetials}
            />
          </>
        )}
      </div>
    </MainComponentWrapper>
  );
};

export default OrderDetail;
